import { render, staticRenderFns } from "./PointsTickets.vue?vue&type=template&id=3f36383f&scoped=true"
import script from "./PointsTickets.vue?vue&type=script&lang=js"
export * from "./PointsTickets.vue?vue&type=script&lang=js"
import style0 from "./PointsTickets.vue?vue&type=style&index=0&id=3f36383f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f36383f",
  null
  
)

export default component.exports